import { FormControl, Grid, VStack } from '@chakra-ui/react'
import { Controller, useFormContext } from 'react-hook-form'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import { overrideText } from 'ui/lib/overrides'
import { type CountryCode } from 'ecosystem'
import { CheckoutCountrySelect } from '../CheckoutCountrySelect'
import { type NshiftCheckoutFormValues } from './types'
import { NshiftFormField, NshiftFormFieldLabel } from './NshiftFormField'
import { type NshiftOverrides } from './translations'

interface NshiftAddressProps {
  isRequiredStreetAddress?: boolean
  availableCountries?: CountryCode[]
}

export const NshiftAddress = ({
  isRequiredStreetAddress,
  availableCountries
}: NshiftAddressProps) => {
  const overrides = useOverridesContext<keyof NshiftOverrides>()
  const form = useFormContext<NshiftCheckoutFormValues>()

  return (
    <VStack spacing={4} align="stretch" w="100%" id="nshift-address-form">
      <Grid
        gap={4}
        templateColumns={{
          base: '1fr',
          sm: '1fr 2fr'
        }}
      >
        <NshiftFormField
          name="postCode"
          label={overrideText('Postnummer', overrides?.fieldPostalCodeLabel)}
          formControlProps={{
            isRequired: true
          }}
          controllerProps={{
            rules: {
              required: {
                value: true,
                message: overrideText('Obligatoriskt', overrides?.errorRequired)
              }
            }
          }}
        />

        <Controller
          name="countryCode"
          render={({ field }) => (
            <FormControl isDisabled={false}>
              <NshiftFormFieldLabel>
                {overrideText('Land', overrides?.fieldCountryCodeLabel)}
              </NshiftFormFieldLabel>

              <CheckoutCountrySelect
                instanceId="nshift-country-select"
                availableCountries={availableCountries}
                defaultValue={form.formState.defaultValues?.countryCode}
                value={field.value}
                selectProps={{
                  onChange: (newValue) => {
                    field.onChange(newValue!.value)
                  },
                  onBlur: field.onBlur
                }}
              />
            </FormControl>
          )}
        />
      </Grid>

      <NshiftFormField
        name="city"
        label={overrideText('Stad', overrides?.fieldCityLabel)}
        formControlProps={{
          isRequired: true
        }}
        controllerProps={{
          rules: {
            required: {
              value: true,
              message: overrideText('Obligatoriskt', overrides?.errorRequired)
            }
          }
        }}
      />

      <NshiftFormField
        name="address"
        label={overrideText('Adress', overrides?.fieldAddressLabel)}
        formControlProps={{
          isRequired: isRequiredStreetAddress
        }}
        controllerProps={{
          rules: {
            required: {
              value: !!isRequiredStreetAddress,
              message: overrideText('Obligatoriskt', overrides?.errorRequired)
            }
          }
        }}
      />
    </VStack>
  )
}
